var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCosmoMark24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-label": "CoSMo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoSMo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cosmoOrbitClear",
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -8,
    width: 80,
    height: 80
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 80,
    height: 80,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.04 6.38) scale(0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14H40A9 9 0 0 1 49 23V32A9 9 0 0 1 40 41H26C24.5 44.6 21.2 47.6 16.8 49.2C15.6 49.6 14.8 48.4 15.5 47.4C17.3 44.8 18.2 42.3 18.4 39.6A9 9 0 0 1 15 32V23A9 9 0 0 1 24 14Z",
    stroke: "#000000",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 16.9,
    r: 5.4,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cosmoBubbleDots",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 44,
    height: 45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 44,
    height: 45,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27.5,
    r: 3.4,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 27.5,
    r: 3.4,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 27.5,
    r: 3.4,
    fill: "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.91 -1.91) scale(0.435)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#cosmoOrbitClear)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 32 32)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 27,
    ry: 20,
    stroke: "#0091BA",
    strokeWidth: 3.4
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 16.9,
    r: 3.8,
    fill: "#0091BA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.04 6.38) scale(0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#cosmoBubbleDots)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14H40A9 9 0 0 1 49 23V32A9 9 0 0 1 40 41H26C24.5 44.6 21.2 47.6 16.8 49.2C15.6 49.6 14.8 48.4 15.5 47.4C17.3 44.8 18.2 42.3 18.4 39.6A9 9 0 0 1 15 32V23A9 9 0 0 1 24 14Z",
    fill: "#004D9E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmoMark24);
export default __webpack_public_path__ + "static/media/CosmoMark24.36c88c3d09636dec2aae9dcd172f514d.svg";
export { ForwardRef as ReactComponent };